import {useState} from "react";
import {css, Theme} from "@emotion/react";
import {appLink, appPath} from "@rw/cars_routes";
import {carsTheme} from "@rw/themes";

import {logout as logoutSession} from "../../admin/auth/auth_client";
import {Spinner} from "../../app/components/Spinner";
import {DashboardWrapper} from "../DashboardWrapper";
import useAuthorisation from "../hooks/useAuthorise";
import {EditCar} from "./EditCar";

export const EditDynamic = () => {
    const [nonceCode, setNonceCode] = useState<string | null>(null);
    const {isAuthenticated, user, setIsAuthenticated, errMessage} = useAuthorisation();

    const handleDashView = () => {
        window.location.href = appLink.admin.userDashboard;
    };

    const logout = async () => {
        setIsAuthenticated(false);
        await logoutSession().catch(() => undefined);
        window.location.href = appPath.admin.login;
    };

    if (isAuthenticated === null) {
        return (
            <DashboardWrapper>
                <div css={containerStyle}>
                    <span>Authoryzacja... </span>
                    <Spinner />
                </div>
            </DashboardWrapper>
        );
    }

    if (!isAuthenticated) {
        setTimeout(() => {
            window.location.href = appPath.admin.login;
        }, 3000);
        return (
            <DashboardWrapper>
                <div css={containerStyle}>{errMessage}</div>
            </DashboardWrapper>
        );
    }

    return (
        <DashboardWrapper>
            <p css={logoutStyle} onClick={logout}>
                {user.displayName ? user.displayName : null} Wyloguj
            </p>
            <div css={container}>
                <div css={aside}>
                    <ul css={asideNav}>
                        <li css={inactive} onClick={handleDashView}>
                            Wróć do panelu
                        </li>
                    </ul>
                </div>
                <div css={contentWrapper}>
                    <EditCar user={user} nonce={nonceCode} />
                </div>
            </div>
        </DashboardWrapper>
    );
};

const inactive = css`
    border-bottom: 2px solid #fff;
    color: #000;
`;
const asideNav = (theme: Theme) => css`
    li {
        list-style: none;
        margin-bottom: 6px;

        &:hover {
            cursor: pointer;
            color: ${theme.colors.brand_primary};
        }
    }
`;
const contentWrapper = css`
    width: 100%;
`;
const aside = css`
    width: 300px;
    height: 100%;
    padding: 0 4rem 0 0;
`;

const container = css`
    max-width: 1190px;
    margin: 1rem auto;
    display: flex;
`;
const logoutStyle = (theme: Theme) => css`
    &:hover {
        color: ${theme.colors.brand_primary};
    }
`;

const containerStyle = css`
    padding: 4rem;
`;
